export default __webpack_public_path__ + "static/media/flag-malta.359efabe.svg";